import React, { useCallback } from 'react';
import moment from 'moment-timezone';
import { fetchStarterWarehouseList } from 'service/service';
import CustomAnalysisTableBase from './CustomAnalysisTableBase';

const columnMapping: Record<string, string> = {
    "workspace_id": "Workspace ID",
    "workspace_name": "Workspace Name",
    "warehouse_id": "Warehouse ID",
    "warehouse_name": "Warehouse Name",
    "account_id": "Account ID",
    "warehouse_type": "Warehouse Type",
    "warehouse_channel": "Warehouse Channel",
    "warehouse_size": "Warehouse Size",
    "min_clusters": "Min Clusters",
    "max_clusters": "Max Clusters",
    "auto_stop_minutes": "Auto Stop (Min)",
    "change_time": "Change Time",
    "delete_time": "Delete Time",
    "created_by": "Created By"
};

const defaultColumns = ['Workspace ID', 'Workspace Name', 'Warehouse ID', 'Warehouse Name', 'Account ID', 'Warehouse Type', 'Warehouse Channel', "Warehouse Size", 'Min Clusters', 'Max Clusters', 'Auto Stop (Min)', 'Change Time', 'Delete Time', 'Created By'];

const StarterWarehouses = () => {
    const filterTableDataFn = useCallback((data: any[]) => {
        return data.map((row) => {
            const filtered: Record<string, any> = {};
            Object.keys(columnMapping).forEach((key) => {
                if (key === "change_time" || key === "delete_time") {
                    filtered[key] = row[key]
                        ? moment(row[key]).tz('America/Chicago').format('MM/DD/YYYY')
                        : "NA";
                } else {
                    filtered[key] = row[key];
                }
            });
            return filtered;
        });
    }, []);

    return (
        <CustomAnalysisTableBase
            fetchService={fetchStarterWarehouseList}
            columnMapping={columnMapping}
            defaultColumns={defaultColumns}
            filterTableDataFn={filterTableDataFn}
            breadcrumbLabel="Starter Warehouses"
            tableTitle="Starter Warehouses"
            tableType="starter-warehouse"
            preserveFilterKey="starter_warehouse_filters"
            isAutoWidth={true}
        />
    );
};

export default StarterWarehouses;
